import { render } from "./ConfigureCampaigns.vue?vue&type=template&id=5299598a"
import script from "./ConfigureCampaigns.vue?vue&type=script&lang=js"
export * from "./ConfigureCampaigns.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__